import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import api from '@survey/api'

import GridView from '@appbase/components/GridView/GridView.vue'
import ModalLayout from '@appbase/templates/ModalLayout/ModalLayout.vue'
import modalHelper from '@appbase/util/modal-helper'
import { dispatchEventBus } from '@appbase/util'
import * as accountType from '@account/store/types'
import { mapGetters } from 'vuex'

@Component({
    components: {
        ModalLayout,
        GridView
    },
    computed: mapGetters({
        current: accountType.CURRENT,
           
      })
})
export default class GradeSelectModal  extends Vue {
    @Prop({ type: Object }) value!: { eventname: string };
    current!:account.TCurrent

    gradeHeaders: gridView.Header[] = [
        { displayName: this.$t('직급명').toString(), rowKey: 'gradeName', align: 'left', width: '200px' }
    ];
    gradeModels: gridView.ModelItem<survey.OrgGrade>[] = [];
    selectedGrades: survey.OrgGrade[] = [];
    companyModels: gridView.ModelItem<appbase.company.Info>[] = [];
    selectedCompany:string =""

    created() {
        api.survey.getOrgCompanys().then(res => {
            this.companyModels = res.companies;
        });
        this.selectedCompany = this.current.user.comCode

    }

    onConfirmClick() {
        dispatchEventBus(window, this.value.eventname, this.selectedGrades);
        modalHelper.close();
    }

    onCancelClick() {
        modalHelper.close();
    }

    @Watch('selectedCompany')
    changedComcode(val:string){
        api.survey.getOrgGrades(val).then(res => {
            this.gradeModels = res;
        });
    }
}